import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { RolesService } from '../services/roles.service';

const CIW_ROLE_PREFIX = 'Ciw';

// Gates the lazy `investigations` route behind a configuration feature flag AND a Ciw* role -
// both must pass or the route does not resolve. Returns a UrlTree (rather than calling
// router.navigate() and returning false) so a direct/deep unauthorised URL redirects to
// /request-access as part of the SAME navigation - the two-step cancel-then-navigate pattern can
// leave the router outlet briefly empty on a hard URL entry, which is the "broken shell" this
// guard must never produce.
export const investigationsFeatureGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const redirectToRequestAccess = () => router.createUrlTree(['/request-access']);

  if (!(environment as any).featureFlags?.investigations) {
    return redirectToRequestAccess();
  }

  const rolesService = inject(RolesService);
  const hasRole = await rolesService.hasRolePrefix(CIW_ROLE_PREFIX);
  if (!hasRole) {
    return redirectToRequestAccess();
  }

  return true;
};
